"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgThumbUp = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M19.42 3.5a3.16 3.16 0 0 0-2.281.98 3.35 3.35 0 0 0-.924 2.318v1.587c0 1.78-.678 3.478-1.874 4.724a6.3 6.3 0 0 1-2.636 1.65v2.073a8.27 8.27 0 0 0 4.08-2.339c1.56-1.627 2.43-3.825 2.43-6.108V6.798c0-.358.137-.692.367-.933.23-.239.531-.365.837-.365s.608.126.837.365c.23.24.367.575.367.933v3.454c0 .555.178 1.098.513 1.544a2.47 2.47 0 0 0 1.381.918l1.409.32c.751.2 1.423.667 1.895 1.332.475.67.716 1.495.676 2.337v.003l-.293 5.18a5.22 5.22 0 0 1-1.594 3.281c-.9.848-2.06 1.311-3.257 1.31h-4.785c-.45 0-.896-.064-1.328-.193l-3.535-1.053v2.087l2.964.882a6.7 6.7 0 0 0 1.898.278h4.786a6.75 6.75 0 0 0 4.629-1.856A7.22 7.22 0 0 0 28.2 22.02l.294-5.209v-.007a5.73 5.73 0 0 0-1.043-3.596 5.4 5.4 0 0 0-3.064-2.12l-1.407-.32a.47.47 0 0 1-.245-.173.57.57 0 0 1-.112-.343V6.798c0-.862-.328-1.696-.924-2.317a3.16 3.16 0 0 0-2.28-.981", clipRule: "evenodd" }),
    React.createElement("rect", { width: 6.245, height: 15.702, x: 3.5, y: 12.798, fill: "#fff", fillOpacity: 0.48, rx: 1 })));
exports.default = SvgThumbUp;
